<div class="dialog-container">
  <h2 mat-dialog-title>{{ 'dialog_upload_justificatives_title' | translate }}</h2>

  <mat-dialog-content>
    <div class="dropzone" [class.dragging]="isDragging" (click)="fileInput.click()" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
      <input type="file" #fileInput hidden multiple (change)="onFileSelected($event)" accept=".jpeg,.jpg,.png,.doc,.docx,.csv,.pdf,.xls,.xlsx" />
      <mat-icon>cloud_upload</mat-icon>
      <span>{{ 'dialog_upload_justificatives_dropzone' | translate }}</span>
    </div>

    <div class="files-list" *ngIf="filesToUpload.length > 0">
      <div *ngFor="let item of filesToUpload; let i = index" class="file-item" [formGroup]="item.form">
        <div class="file-header">
          <a [href]="createFileUrl(item.file)" target="_blank" class="file-link" [matTooltip]="'dialog_justificative_tooltip_open' | translate">
            <mat-icon>description</mat-icon>
            <span class="file-name">{{ item.file.name }}</span>
            <span class="file-size">({{ item.file.size / 1024 | localizedNumber: '1.1-1' }} KB)</span>
          </a>
          <button mat-icon-button color="warn" (click)="removeFile(i)" [matTooltip]="'dialog_justificative_tooltip_remove' | translate">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <div class="file-form-fields">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>{{ 'dialog_upload_justificatives_field_resources' | translate }}</mat-label>
            <mat-select formControlName="resourceIds" multiple>
              <mat-option *ngFor="let resource of availableResources" [value]="resource.id">
                {{ resource.displayName }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="item.form.get('resourceIds')?.hasError('required')">{{ 'dialog_upload_justificatives_error_required' | translate }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>{{ 'dialog_justificative_field_data' | translate }}</mat-label>
            <mat-select formControlName="justificationTypes" multiple>
              <mat-option *ngFor="let option of justificationOptions" [value]="option">{{ option | translate }}</mat-option>
            </mat-select>
            <mat-error *ngIf="item.form.get('justificationTypes')?.hasError('required')">{{ 'dialog_upload_justificatives_error_required' | translate }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field full-width">
            <mat-label>{{ 'dialog_justificative_field_comment' | translate }}</mat-label>
            <textarea matInput formControlName="comment" rows="2"></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">{{ 'common_btn_cancel' | translate }}</button>
    <button mat-flat-button color="accent" [disabled]="!isFormValid()" (click)="onSave()">{{ 'dialog_upload_justificatives_btn_add' | translate: { count: filesToUpload.length } }}</button>
  </mat-dialog-actions>
</div>
